import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/customer_flow_steps';

const model = abstractModel(resource);
const parentGet = model.get;
const parentSave = model.save;
const parentPut = model.put;
const parentDelete = model.remove;

model.get = (params = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some((value) => Array.isArray(value));
    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { path: resource, filters: queryString });
    }
  }

  const queryString = serializeParams(params);
  return parentGet({}, { path: `${resource}?${queryString}` });
};

model.retrieve = (fieldId) => parentGet({}, { path: `${resource}/${fieldId}` });
model.save = (data) => parentSave(data, { path: resource, csrfToken });
model.update = (fieldId, data) => parentPut(data, { path: `${resource}/${fieldId}`, csrfToken });
model.delete = (fieldId) => parentDelete({ id: fieldId }, { path: resource, csrfToken });

export default model;
